import { render, staticRenderFns } from "./joinACall.vue?vue&type=template&id=76272feb&"
import script from "./joinACall.vue?vue&type=script&lang=js&"
export * from "./joinACall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "joinACall.vue"
export default component.exports